import { createAsyncThunk } from "@reduxjs/toolkit"

import type { IPractice } from "@common-shared/types/responseData/commonResponseData.types.ts"

import { ToastrHelper } from "@front-shared/helpers/toastr.helper.tsx"

import { AuthHelper } from "../../helpers/auth.helper"
import { FeatureFlagsService } from "../../services/featureFlags.service"
import type { IThunkActionData } from "../../types/general.types.ts"
import {
    runtimeSetEnabledFeatureFlags,
    runtimeStartLoading,
    runtimeStopLoading,
} from "../slices/runtime.slice"

/**
 * Check if user is logged in and set that in state
 */
export const runtimeCheckUserIsLoggedIn = createAsyncThunk<boolean>(
    "runtimeCheckUserIsLoggedInPrefix",
    async () => {
        return await AuthHelper.isLoggedIn()
    },
)

/**
 * Get enabled feature flags for practice / user
 */
export const runtimeGetEnabledFeatureFlags = createAsyncThunk<
    void,
    IThunkActionData<IPractice>
>("runtimeGetEnabledFeatureFlagsPrefix", async (action, { dispatch }) => {
    dispatch(runtimeStartLoading("runtimeGetEnabledFeatureFlagsLoading"))

    try {
        const result = await FeatureFlagsService.getEnabledFeatureFlags(
            action.payload,
        )

        if (result) {
            dispatch(runtimeSetEnabledFeatureFlags(result))

            action.onSuccess?.(result)
        } else {
            ToastrHelper.error(
                "Failed to get enabled feature flags. Please try again or contact support.",
            )

            action.onError?.(result)
        }
    } catch (e) {
    } finally {
        dispatch(runtimeStopLoading("runtimeGetEnabledFeatureFlagsLoading"))

        action.onFinally?.()
    }
})
